/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Export_LabelInputs */

const en_manual_qc_export_label = /** @type {(inputs: Manual_Qc_Export_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export issues`)
};

const fr_manual_qc_export_label = /** @type {(inputs: Manual_Qc_Export_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter les incidents`)
};

const de_manual_qc_export_label = /** @type {(inputs: Manual_Qc_Export_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportfragen`)
};

const it_manual_qc_export_label = /** @type {(inputs: Manual_Qc_Export_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problemi di esportazione`)
};

const ru_manual_qc_export_label = /** @type {(inputs: Manual_Qc_Export_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вопросы экспорта`)
};

const es_manual_qc_export_label = /** @type {(inputs: Manual_Qc_Export_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problemas de exportación`)
};

const zh_cn2_manual_qc_export_label = /** @type {(inputs: Manual_Qc_Export_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出口问题`)
};

const ja_manual_qc_export_label = /** @type {(inputs: Manual_Qc_Export_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`輸出に関する問題`)
};

const hi_manual_qc_export_label = /** @type {(inputs: Manual_Qc_Export_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात संबंधी मुद्दे`)
};

const pt_pt2_manual_qc_export_label = /** @type {(inputs: Manual_Qc_Export_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questões de exportação`)
};

/**
* | output |
* | --- |
* | "Export issues" |
*
* @param {Manual_Qc_Export_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_export_label = /** @type {((inputs?: Manual_Qc_Export_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Export_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_export_label(inputs)
	if (locale === "de") return de_manual_qc_export_label(inputs)
	if (locale === "it") return it_manual_qc_export_label(inputs)
	if (locale === "ru") return ru_manual_qc_export_label(inputs)
	if (locale === "es") return es_manual_qc_export_label(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_export_label(inputs)
	if (locale === "ja") return ja_manual_qc_export_label(inputs)
	if (locale === "hi") return hi_manual_qc_export_label(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_export_label(inputs)
	return en_manual_qc_export_label(inputs)
});